import { render, staticRenderFns } from "./ShipCard.vue?vue&type=template&id=1945e596&"
import script from "./ShipCard.ts?vue&type=script&lang=ts&"
export * from "./ShipCard.ts?vue&type=script&lang=ts&"
import style0 from "./ShipCard.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports